<template>
  <div>
    <div>Propositions:</div>
    <div v-if="loading"><b-spinner></b-spinner></div>
    <div v-else-if="proposals.length===0">Aucune proposition</div>
    <div v-else>
      <b-row>
        <b-col>
          <b-button-group class="ml-3">
            <b-button variant="primary" @click="selectAllProposals">Sélectionner tout</b-button>
            <b-button variant="primary" @click="clearProposalsSelection">Désélectionner tout</b-button>
          </b-button-group>
          <b-form-radio-group class="float-right mr-3" buttons>
            <b-form-radio variant="light" v-model="display_mode" value="card"><i class="fas fa-table"></i></b-form-radio>
            <b-form-radio variant="light" v-model="display_mode" value="table"><i class="fas fa-list"></i></b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
        <b-form-checkbox-group v-model="selected_proposals">
          <b-row v-if="display_mode==='card'" class="ml-3 mr-3">
            <b-col class="mt-3" v-for="proposal in proposals" :key="proposal.id" cols=12 lg=3 md=4 sm=6>
              <b-card v-if="proposal.soc">
                <b-form-checkbox :value=proposal.id></b-form-checkbox>
                <a :href="buildThirdpartyURL(dolibarr_url, proposal.socid)">{{proposal.soc.name}}</a>
                <span> - </span>
                <a :href="buildProposalURL(dolibarr_url, proposal.id)">{{proposal.ref}}</a>
                <br>

                <ul>
                  <li v-for="line in proposal.lines" :key="line.id">
                    {{line.array_options.options_domain}} - {{parseFloat(line.multicurrency_total_ht).toFixed(2)}}€ HT
                    <b-badge v-if="line.domain_status.available" variant="success">Disponible</b-badge>
                    <b-badge v-else variant="danger">Indisponible</b-badge>
                  </li>
                </ul>
                <div>total: {{getSumOfProposal(proposal).toFixed(2)}}€ HT</div>
              </b-card>
            </b-col>
          </b-row>

          <div v-if="display_mode==='table'">todo</div>
          <vue-bootstrap4-table v-if="display_mode==='table'" :rows="proposals" :columns="columns" :config="config">
            <template slot="checkbox" slot-scope="props">
              <b-form-checkbox :value=props.row.id></b-form-checkbox>
            </template>
            <template slot="thirdparty" slot-scope="props">
              <a :href="buildThirdpartyURL(dolibarr_url, props.row.socid)">{{props.row.soc.name}}</a>
            </template>
            <template slot="proposal" slot-scope="props">
              <a :href="buildProposalURL(dolibarr_url, props.row.id)">{{props.row.ref}}</a>
            </template>
            <template slot="domains" slot-scope="props">
                <div v-for="line in props.row.lines" :key="line.id">
                  {{line.array_options.options_domain}} - {{parseFloat(line.multicurrency_total_ht).toFixed(2)}}€ HT
                  <b-badge v-if="line.domain_status.available" variant="success">Disponible</b-badge>
                  <b-badge v-else variant="danger">Indisponible</b-badge>
                </div>
            </template>
            <template slot="total" slot-scope="props">
              {{getSumOfProposal(props.row).toFixed(2)}}€ HT
            </template>
          </vue-bootstrap4-table>
        </b-form-checkbox-group>

      <b-button class="mt-3 ml-3" :disabled="sign_proposals_disabled" :variant="sign_proposals_variant" @click="sign_proposals">Créer commande + contrat + commande chez OVH</b-button>
      <b-row>
        <b-col cols=12 lg=6 offset-lg=3>
          <b-alert :show="Boolean(sign_proposals_error)" variant="danger" v-html=sign_proposals_error></b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
    import script from '../../script/script.js';
    export default {
        data() {
            return {
                loading: true,
                display_mode: "card",
                sign_proposals_error: "",
                sign_proposals_disabled: true,
                sign_proposals_variant: "success",
                dolibarr_url: null,
                selected_proposals: [],
                proposals: [],
                columns: [
                    {
                        label: "Séléctionné",
                        name: "checkbox",
                    },
                    {
                        label: "Tier",
                        name: "thirdparty",
                    },
                    {
                        label: "Proposition",
                        name: "proposal",
                    },
                    {
                        label: "Domaines",
                        name: "domains",
                    },
                    {
                        label: "Total HT",
                        name: "total",
                    },
                ],
                config: {
                    show_refresh_button: false,
                    show_reset_button: false,
                    global_search:  {
                        placeholder:  "Recherche globale",
                        visibility:  true,
                        case_sensitive:  false
                    },
                },
            }
        },
        watch: {
            selected_proposals(selected_proposals) {
                this.sign_proposals_error = ""
                this.sign_proposals_disabled = false
                this.sign_proposals_variant = "success"
                if (selected_proposals.length === 0) {
                    this.sign_proposals_disabled = true
                }

                // check if there is the same domain selected 2 times.
                var domain_count = this.$_.countBy(this.proposals.filter(x => selected_proposals.includes(x.id)).map(x => x.lines.map(l => l.array_options.options_domain)).flat())
                for (let [key, value] of Object.entries(domain_count)) {
                    if (value !== 1) {
                        this.sign_proposals_error = `le nom de domaine <strong>${key}</strong> est séléctionné ${value} fois !`
                        this.sign_proposals_disabled = true
                        this.sign_proposals_variant = "danger"
                    }
                }
            },
        },
        created() {
            this.axios.get("/api/domain/proposals")
            .then(response => {
                this.loading = false
                this.dolibarr_url = response.data.dolibarr_url
                this.proposals = response.data.proposals
                this.proposals.forEach(proposal => {
                    proposal.soc = response.data.thirdparties.find(x => x.id == proposal.socid)
                    proposal.lines.forEach(line => {
                        line.domain_status = response.data.domains_status[line.array_options.options_domain]
                    })
                })
            })
            .catch(error => {
                this.loading = false
                if (error.response && error.response.status === 404) {
                    // this case is not an error
                }
                else {
                    console.error(error)
                }
            })
        },
        methods: {
            temp() {
                this.axios.get("/temp")
                .then(r => console.log(r))
                .catch(e => console.error(e))
            },
            buildThirdpartyURL: script.buildThirdpartyURL,
            buildProposalURL: script.buildProposalURL,
            sign_proposals() {
                this.axios.post("api/domain/processOrder", {proposal_ids: this.selected_proposals})
                .then(response => {
                    // after process order force refetch
                    this.proposals = []
                    this.axios.get("/api/domain/proposals")
                    .then(response => {
                        this.dolibarr_url = response.data.dolibarr_url
                        this.proposals = response.data.proposals
                        this.proposals.forEach(proposal => {
                            proposal.soc = response.data.thirdparties.find(x => x.id == proposal.socid)
                            proposal.lines.forEach(line => {
                                line.domain_status = response.data.domains_status[line.array_options.options_domain]
                            })
                        })
                    })
                    .catch(error => {
                        console.error(error)
                    })
                })
                .catch(error => {
                    if (error.response && error.response.status===400 && error.response.data.unavailable_domain) {
                        let content = this.$createElement("div", [
                          "Les noms de domaine suivant sont indisponibles",
                          this.$createElement("ul", error.response.data.unavailable_domain.map(domain => this.$createElement("li", domain)))
                        ])
                        this.$bvToast.toast(content, {
                            title: "Erreur",
                            variant: "danger",
                            noAutoHide: true,
                            solid: true,
                            toaster: "b-toaster-bottom-right",
                        })
                    }
                })
            },
            selectAllProposals() {
                this.selected_proposals = this.proposals.map(x => x.id)
            },
            clearProposalsSelection() {
                this.selected_proposals = []
            },
            getSumOfProposal(proposal) {
                return proposal.lines.map(line => line.multicurrency_total_ht).reduce((total, current_value) => total + parseFloat(current_value), 0)
            }
        },
    }
</script>


<style scoped>

</style>  